import styled from 'styled-components'
import { Typography, Alert } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { COLORS, TYPOGRAPHY } from '../../../styles/theme'

const { Title: AntTitle, Text: AntText } = Typography

/**
 * Styled components for EmailConfirmation component
 * Replaces inline styles with reusable styled components
 */

// Large mail icon with primary color
export const LargeMailIcon = styled(MailOutlined)`
  font-size: ${TYPOGRAPHY.h1.fontSize};
  color: ${COLORS.primary};
`

// Centered title with no margin
export const CenteredTitle = styled(AntTitle)`
  &.ant-typography {
    text-align: center;
    margin: 0;
  }
`

// Full width alert
export const FullWidthAlert = styled(Alert)`
  width: 100%;
`

// Centered secondary text
export const CenteredText = styled(AntText)`
  text-align: center;
`
